// utils/preloadImages.js
export const preloadImages = (imageList) => {
  imageList.forEach((imageSrc) => {
    const img = new Image();
    img.src = imageSrc;
  });
};
